export const CSS_COLORS = {
  border: 'hsl(var(--border))',

  input: 'hsl(var(--input))',

  ring: 'hsl(var(--ring))',

  background: 'hsl(var(--background))',
  foreground: 'hsl(var(--foreground))',

  primary: {
    DEFAULT: 'hsl(var(--primary))',
    dark: 'hsl(var(--primary-dark))',
    light: 'hsl(var(--primary-light))',
    foreground: 'hsl(var(--primary-foreground))',
  },

  secondary: {
    DEFAULT: 'hsl(var(--secondary))',
    dark: 'hsl(var(--secondary-dark))',
    light: 'hsl(var(--secondary-light))',
    foreground: 'hsl(var(--secondary-foreground))',
  },

  destructive: {
    DEFAULT: 'hsl(var(--destructive))',
    dark: 'hsl(var(--destructive-dark))',
    light: 'hsl(var(--destructive-light))',
    foreground: 'hsl(var(--destructive-foreground))',
  },

  info: {
    DEFAULT: 'hsl(var(--info))',
    dark: 'hsl(var(--info-dark))',
    light: 'hsl(var(--info-light))',
    foreground: 'hsl(var(--info-foreground))',
  },

  warning: {
    DEFAULT: 'hsl(var(--warning))',
    dark: 'hsl(var(--warning-dark))',
    light: 'hsl(var(--warning-light))',
    foreground: 'hsl(var(--warning-foreground))',
  },

  success: {
    DEFAULT: 'hsl(var(--success))',
    dark: 'hsl(var(--success-dark))',
    light: 'hsl(var(--success-light))',
    foreground: 'hsl(var(--success-foreground))',
  },

  muted: {
    DEFAULT: 'hsl(var(--muted))',
    foreground: 'hsl(var(--muted-foreground))',
  },

  accent: {
    DEFAULT: 'hsl(var(--accent))',
    foreground: 'hsl(var(--accent-foreground))',
  },

  hover: {
    DEFAULT: 'var(--hover)',
  },

  popover: {
    DEFAULT: 'hsl(var(--popover))',
    foreground: 'hsl(var(--popover-foreground))',
  },

  card: {
    DEFAULT: 'hsl(var(--card))',
    foreground: 'hsl(var(--card-foreground))',
  },
};
